import CleverlyPreset from './cleverly-preset';
import LegacyPreset from './legacy-preset';
import { cleverlySpacing, legacySpacing, type SpacingScale } from './theme/tokens/spacings';

// Runtime theme selection — the Option-C cleanup made every color reference a
// runtime preset token, so swapping the preset object switches the whole theme.
// Spacing/radius geometry is preset-sourced too (radii as static primitive
// tokens, responsive spacing via the preset-owned maps in tokens/spacings.ts).
//
// Usage (devtools, no UI by design):
//   localStorage.setItem('cl-theme', 'legacy'); location.reload();  // old blue brand
//   localStorage.removeItem('cl-theme');   location.reload();       // Cleverly (default)

export type ClThemeName = 'cleverly' | 'legacy';

export const THEME_STORAGE_KEY = 'cl-theme';

export function getStoredThemeName(): ClThemeName {
    try {
        return localStorage.getItem(THEME_STORAGE_KEY) === 'legacy' ? 'legacy' : 'cleverly';
    } catch {
        return 'cleverly'; // SSR / storage disabled
    }
}

/** The preset to hand to providePrimeNG() at bootstrap time. */
export function getStoredPreset(): typeof CleverlyPreset | typeof LegacyPreset {
    return getStoredThemeName() === 'legacy' ? LegacyPreset : CleverlyPreset;
}

/** The responsive spacing scale owned by the active theme. */
export function getStoredSpacingScale(): SpacingScale {
    return getStoredThemeName() === 'legacy' ? legacySpacing : cleverlySpacing;
}
